import type { SVGProps } from 'react';
import { clsx } from 'clsx';
import LoadingSpinnerIcon from '../../../icons/loading/spinner';
import styles from './loading-spinner.module.scss';

export function LoadingSpinner({ className, ...props }: SVGProps<SVGSVGElement>) {
  return <LoadingSpinnerIcon className={clsx(styles.loadingSpinner, className)} {...props} />;
}
